import { Component, OnInit, Input } from '@angular/core';
import { EvaluationVehicle, StatusEvaluation } from '@app-model/evaluation';
import { EvaluationService } from '@app-services/evaluation.service';


@Component({
  selector: 'app-eval-schedule-info',
  templateUrl: './eval-schedule-info.component.html',
  styleUrls: ['./eval-schedule-info.component.scss']
})
export class EvalScheduleInfoComponent implements OnInit {
  @Input() vehicle: EvaluationVehicle;

  loading = false;

  constructor(private evalService: EvaluationService) { }

  ngOnInit() {

  }

  sendToEvaluator(): void {
    this.loading = true;
    this.evalService.sendScheduledToEvaluator(this.vehicle.id)
      .subscribe(resp => {
        if (resp.success) {
          this.vehicle.status = StatusEvaluation.CREATED;
        }
        this.loading = false;
      });
  }

}
